import React, {useRef, useState} from "react";
import useDialogBehavior from "../components/useDialogBehavior";

// Lecteur YouTube (sans cookie) et sa version « agrandir », partagés par la landing et les blocs vidéo des rubriques libres.
export function YouTubeEmbed({videoId, playlistId, title, className = "video-embed-wrap", autoplay = false}) {
    const embedPath = playlistId ? "videoseries" : videoId;
    const query = playlistId ? `list=${playlistId}&rel=0` : "rel=0";
    const src = `https://www.youtube-nocookie.com/embed/${embedPath}?${query}${autoplay ? "&autoplay=1" : ""}`;
    return (
        <div className={className}>
            <iframe
                src={src}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
}

// Lightbox : boîte de dialogue modale (focus piégé, reste de la page inerte, Échap) ; la lecture ne démarre pas toute seule —
// l'agent la lance lui-même, le son ne surprend personne.
function VideoLightbox({title, videoId, playlistId, onClose}) {
    const dialogRef = useRef(null);
    useDialogBehavior(dialogRef, onClose);
    return (
        <div
            ref={dialogRef}
            className="video-lightbox"
            role="dialog"
            aria-modal="true"
            aria-label={title}
            tabIndex={-1}
            onClick={onClose}
        >
            <div className="video-lightbox-inner" onClick={e => e.stopPropagation()}>
                <button type="button" className="video-lightbox-close" aria-label="Fermer" onClick={onClose}>
                    ✕
                </button>
                <YouTubeEmbed videoId={videoId} playlistId={playlistId} title={title}/>
            </div>
        </div>
    );
}

export function ExpandableYouTubeEmbed({videoId, playlistId, title, className = "video-embed-wrap"}) {
    const [expanded, setExpanded] = useState(false);

    return (
        <>
            <YouTubeEmbed videoId={videoId} playlistId={playlistId} title={title} className={className}/>
            <button type="button" className="video-expand-btn" onClick={() => setExpanded(true)}>
                ⤢ Agrandir
            </button>
            {expanded && <VideoLightbox title={title} videoId={videoId} playlistId={playlistId} onClose={() => setExpanded(false)}/>}
        </>
    );
}
